import { wait } from './'

export const onWindowResize = (func: Function) => {
    window.addEventListener('resize', () => {
        wait(100).then(() => {
            func()
        })
    })
}
